<template>
  <v-card v-if="ShowAppBar()">
    <!-- 頂部menu -->
    <v-app-bar app clipped-left class="blue darken-2">
      <v-toolbar-title
        class="font-weight-bold text-h5 TitleWord"
        @click="Test()"
        >廠商資訊平台</v-toolbar-title
      >

      <v-spacer></v-spacer>

      <!-- 使用者Icon + menu -->
      <v-menu open-on-hover :close-on-content-click="false" offset-y
        ><template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" style="color: #ffffff">
            <v-icon color="" large dark>mdi-account-circle</v-icon>

            {{ UserName }}
          </div>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in TopItems"
            :key="index"
            @click="SwitchPage(item.BaseURL, item.Content.route)"
          >
            <v-list-item-icon>
              <v-icon>{{ item.Content.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.Content.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- 側邊menu -->
    <v-navigation-drawer
      app
      permanent
      :style="{ top: $vuetify.application.top + 'px', zIndex: 4 }"
    >
      <v-divider></v-divider>
      <!-- StyleA -->
      <v-expansion-panels accordion v-model="Panel">
        <v-expansion-panel
          v-for="(item, index) in index.RouteItem"
          :key="item.MainRoute"
        >
          <v-expansion-panel-header
            v-if="item.ChildRoute.length != 0 ? true : false"
            :class="Panel == index ? 'focus' : 'normal'"
          >
            {{ item.MainRouteName }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list-item
              v-for="child in item.ChildRoute"
              :key="child.MainRouteName"
              @click="SwitchPage(item.BaseURL, child.route, child.params)"
              link
              dense
              class="pt-1 pb-1 tile"
              :class="CheckRoute(item.BaseURL, child) ? 'tileUse' : 'tile'"
            >
              <v-list-item-icon>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ child.routeName }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item></v-expansion-panel-content
          >
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- StyleB -->
      <!-- <v-list
        dense
        nav
        v-for="item in index.RouteItem"
        :key="item.MainRoute"
        class="pa-0"
      >
        <v-divider></v-divider>

        <v-list-item-title v-if="item.ChildRoute.length != 0 ? true : false">
          <span class="ml-3"> {{ item.MainRouteName }}</span></v-list-item-title
        >
        <v-divider></v-divider>
        <v-list-item
          v-for="child in item.ChildRoute"
          :key="child.routeName"
          @click="SwitchPage(item.BaseURL, child.route, child.params)"
          link
        >
          <v-list-item-icon class="ml-3">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ child.routeName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
    </v-navigation-drawer>
  </v-card>
</template>
<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.focus {
  color: rgb(60, 94, 158);
}
.normal {
  background-color: white;
}

.tile {
  margin: 5px;
  border-radius: 4px;
}
.tile:hover {
  background: rgb(224, 235, 250);
}
.tile:active {
  background: rgb(136, 169, 207);
}
.tileUse {
  margin: 5px;
  border-radius: 4px;
  background: rgb(224, 235, 250);
}
.TitleWord {
  color: #ffffff;
}
.TitleWord:hover {
  color: rgb(228, 228, 228);
  cursor: default;
}
</style>
<script>
import { mapState } from "vuex";
// import { apiVerify } from "../utils/request/account";
export default {
  components: {},
  data: () => ({
    UserName: null,
    TopItems: [
      {
        BaseURL: null,
        Content: { title: "登出", icon: "mdi-logout", route: "login" },
      },
      {
        BaseURL: "account",
        Content: {
          title: "變更密碼",
          icon: "mdi-lock-reset",
          route: "changepassword",
        },
      },
    ],
    Panel: 0,
  }),
  methods: {
    //切換路由
    SwitchPage(baseURL, routeName, p) {
      let inputPath = p
        ? `/${baseURL}/${routeName}/${p}`
        : `/${baseURL}/${routeName}`;

      if (inputPath === this.$route.path || !routeName) return;

      if (routeName === "login") {
        localStorage.removeItem("Token");
        localStorage.removeItem("Account");
        localStorage.removeItem("UserName");
        localStorage.removeItem("Admin");
      }

      this.$router.push({ path: inputPath });
    },
    //根據當前路由判斷是否顯示AppBar
    ShowAppBar() {
      if (this.$route.path.toLowerCase() !== "/login") return true;
      else return false;
    },
    Test() {
      if (this.$route.path.indexOf("home") == 1) return;
      this.$router.push({ name: "home" });
    },
    //更改menu當下路徑的顏色
    CheckRoute(BaseURL, child) {
      //比對v-for產生項目的路徑與當前url路徑是否相等
      if (
        this.$route.path.indexOf(child.route) != -1 &&
        this.$route.path.indexOf(BaseURL) != -1
      ) {
        if (!child.params) return true;
        if (this.$route.path.indexOf(child.params) != -1) return true;
      }
      return false;
    },
  },
  //localstorage無法監聽
  watch: {
    "$store.state.users.UserName": function () {
      this.UserName = this.$store.state.users.UserName;
    },
  },

  computed: {
    ...mapState({
      index: (state) => state,
    }),
  },
};
</script>
